import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Table, Loader, Button, Grid, Popup, Icon, TextArea} from 'semantic-ui-react';
import {ordersStatus} from '../../../../common/dictionaries/accessories';
import {Actions} from '../../../../common/actions';
import './stockDownload.scss';

class StockDownloadModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'availableStock': true,
      'reversalReason': '',
    };
    this.renderTable = this.renderTable.bind(this);
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
    this.handleReversalReasonChange = this.handleReversalReasonChange.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    const {accessoryOrder} = this.props;
    const params = {
      'showStockInLog': 'yes',
      'chassis': accessoryOrder.chassis,
      'katashiki': accessoryOrder.katashiki,
    };
    this.props.fetchPartsByOrder(accessoryOrder.order, params);
  }

  handleReversalReasonChange(event, {value}) {
    this.setState({'reversalReason': value});
  }

  onCloseModalClick() {
    this.props.onCloseModal();
  }

  onStockDownloadClick(action) {
    const {accessoryOrder} = this.props;
    const {reversalReason} = this.state;
    const data = {action};
    if (action === 'revert') {
      data.reversalReason = reversalReason;
    }
    this.props.downloadStockToOrder(accessoryOrder.order, data);
    this.onCloseModalClick();
  }
  
  renderItems() {
    const {list} = this.props;
    const {availableStock} = this.state;
    if (!list.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={6}>No hay datos Disponibles</Table.Cell>
        </Table.Row>
      );
    }

    return list.map((item, index) => {
      const isNegative = item.availableStockInWarehouse - item.quantity < 0;
      if (availableStock && isNegative) {
        this.setState({'availableStock': false});
      }

      return (
        <Table.Row key={index} negative={isNegative} >
          <Table.Cell textAlign='center'>{item.partCode}</Table.Cell>
          <Table.Cell textAlign='center'>{item.partName}</Table.Cell>
          <Table.Cell textAlign='center'>{item.quantity}</Table.Cell>
          <Table.Cell textAlign='center'>{item.availableStockInWarehouse}</Table.Cell>
        </Table.Row>
      );
    });
  }

  getTechniciansOptions() {
    return this.props.techniciansList.map((item) => {
      return {'text': `${item.technician} - ${item.name}`, 'value': item.technician};
    });
  }

  allowDownloadStockReversion = (accessoryOrder) => {
    return accessoryOrder.status === ordersStatus.closed_order;
  }

  renderData() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row className='loader'>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderItems();
  }
  
  renderTable() {
    return (
      <Table striped className='toyota-grid'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>Código del Item</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Nombre</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Cantidad Requerida</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Stock LOG</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {this.renderData()}
        </Table.Body>
      </Table>
    );
  }

  render() {
    const {accessoryOrder, type, sfx, loading, list, modalWasOpen} = this.props;
    const {availableStock, reversalReason} = this.state;

    return (
      <Modal size='fullscreen' className='stock-download-modal' open={modalWasOpen}>
        <Modal.Header>
          Descarga de stock para la orden: {accessoryOrder.order}
          <Popup
            trigger={
              <Icon link name='info circle' color='blue' size='large' />
            }
            on='click'
            position='bottom left'
            inverted
          >
            <div>
              Los items que están en color rojo no tienen existencias para realizar la descarga
            </div>
          </Popup>
        </Modal.Header>
        
        <Modal.Content scrolling>
          <Modal.Description>
            <div className='title-bar'>
              <div className='filters-section'>
                <Grid textAlign='left'>
                  <Grid.Row>
                    <Grid.Column width={1}>
                      <h4>Katashiki:</h4>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      {sfx} / {accessoryOrder.katashiki}
                    </Grid.Column>
                    <Grid.Column width={1}>
                      <h4>Modelo:</h4>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      {accessoryOrder.description}
                    </Grid.Column>
                    <Grid.Column width={1}>
                      <h4>Chasis:</h4>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      {accessoryOrder.chassis}
                    </Grid.Column>
                    <Grid.Column width={1}>
                      {type === 'accessories' &&
                      <h4>Combo:</h4>}
                    </Grid.Column>
                    <Grid.Column width={1} textAlign='right'>
                      {type === 'accessories' &&
                      accessoryOrder.combo}
                    </Grid.Column>
                  </Grid.Row>
                  {this.allowDownloadStockReversion(accessoryOrder) &&
                  <Grid.Row>
                    <Grid.Column width={16}>
                      <h4>Por favor ingrese la justificación para poder revertir la orden
                        <span className='required'>*</span>:
                      </h4>
                      <TextArea maxLength='200' rows='4' value={reversalReason}
                        className={reversalReason ? '' : 'error'}
                        onChange={this.handleReversalReasonChange} />
                    </Grid.Column>
                  </Grid.Row>
                  }
                </Grid>
              </div>
            </div>

            {this.renderTable()}
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={this.onCloseModalClick}>
            Cancelar
          </Button>
          {(accessoryOrder.status === ordersStatus.wash_wait ||
            (accessoryOrder.anticipatedInvoice === 'S' &&
            accessoryOrder.status === ordersStatus.created_order)) &&
          <Button positive
            disabled={loading || !list.length || !availableStock}
            onClick={() => this.onStockDownloadClick('download')}>
            Descargar
          </Button>
          }
          {this.allowDownloadStockReversion(accessoryOrder) &&
          <Button positive
            disabled={loading || !list.length || !reversalReason}
            onClick={() => this.onStockDownloadClick('revert')}>
            Revertir
          </Button>
          }
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.stockDownload.loading,
    'list': state.stockDownload.parts,
    'sfx': state.stockDownload.sfx,
  };
};

const {
  fetchPartsByOrder,
  downloadStockToOrder,
} = Actions;

export default connect(mapStateToProps, {
  fetchPartsByOrder,
  downloadStockToOrder,
})(StockDownloadModal);
